const mapProductGroupNameToItemGroupCode = {
  'DIGITAL TV ACC.': 'DIGITAL_TV_ACCESSORIES',
  'UNIVERSAL RC': 'UNIVERSAL_REMOTECONTROLS',
  'CAR AUDIO': 'CAR_AUDIO',
  'CAR NAVIGATION': 'CAR_NAVIGATION',
  'CAR SPEAKERS': 'CAR_SPEAKERS',
  'CAR VISION': 'CAR_VISION',
  'RADIO DEVICES (TABLE TOP)': 'RADIO_DEVICES_(TABLE_TOP)',
  AMPLIFIER: 'AMPLIFIER',
  'CD-PLAYER': 'CD_PLAYER',
  LOUDSPEAKERS: 'LOUDSPEAKERS',
  RECEIVER: 'RECEIVER',
  TUNER: 'TUNER',
  TURNTABLE: 'TURNTABLE',
  CAMCORDER: 'CAMCORDER',
  'VIDEO PLAYER/REC.': 'VIDEO_PLAYER_AND_RECORDERS',
  'PTV/FLAT': 'PTV_FLAT',
  'SET-TOP-BOXES': 'SET_TOP_BOXES',
  'VG CONSOLES': 'VIDEO_GAMES_HARDWARE',
  'GAMES SOFTW': 'GAMES_SOFTWARE',
  COOKING: 'COOKING',
  COOLING: 'COOLING',
  DISHWASHERS: 'DISHWASHERS',
  FREEZERS: 'FREEZERS',
  'FREESTAND. HOBS': 'FREESTANDING_HOBS',
  'BUILT IN HOBS': 'BUILTINHOBS',
  HOODS: 'HOODS',
  'MICROWAVE OVENS': 'MICROWAVE_OVENS',
  'STEAM OVENS': 'STEAM_OVENS',
  TUMBLEDRYERS: 'TUMBLE_DRYERS',
  WASHINGMACHINES: 'WASHINGMACHINES',
  'WINE CABINETS': 'WINE_CABINETS',
  'AIR CONDITIONER': 'AIRCONDITIONING',
  'DENTAL CARE': 'DENTAL_CARE',
  FOODPREPARATION: 'FOODPREPARATION',
  'FUN COOKING': 'FUN_COOKING',
  'HOT BEVER.MAKER': 'HOT_BEVER_MAKER',
  KETTLES: 'KETTLES',
  'SHAVER ACCESSOR': 'SHAVER_ACCESSORIES',
  SHAVERS: 'MALESHAVERS',
  HOUSINGS: 'HOUSINGS',
  'MULTIDISC DRIVE': 'MULTIDISC_DRIVE',
  STORAGE: 'STORAGE',
  'DESK COMPUTING': 'DESKBOUND_COMPUTERS',
  'DIGITAL ASSISTANTS': 'DIGITAL_ASSISTANTS',
  MONITORS: 'MONITORS',
  'GAMING & LEISURE DEVICES': 'GAMING_AND_LEISURE_DEVICES',
  'KEYING DEV': 'KEYING_DEV',
  'POINTING DEV': 'POINTING_DEV',
  'SECURITY CAMS': 'VISUAL_CAMS',
  'COMM. CARDS': 'COMMUNICATION_CARDS',
  'COMM.DEVICE': 'COMMUNICATION_DEVICES',
  'MM-DEVICES': 'MM-DEVICES',
  'SEC-DEVICES': 'SECURITY_DEVICES',
  SOFTWARE: 'FINANCIAL_SOFTWARE',
  HEADSETS: 'HEADSETS_TOTAL',
  MICROPHONES: 'MICROPHONES',
  'AV MOUNTING SOLUTIONS AND FURN': 'AV_MOUNTING_SOLUTIONS_AND_FURN',
  'ES&PT VGS': 'ES_AND_PT_VGS',
  'DRINK CHILLERS': 'DRINK_CHILLERS',
  MAINBOARDS: 'MAINBOARDS',
  'MEDIA GATEWAYS': 'MEDIA_GATEWAYS',
  'MOBILE COMPUTING': 'MOBILE_COMPUTING',
  'ERGONOMIC ACC.': 'ERGONOMIC_ACCESSORIES',
  'LEISURE GPS': 'LEISURE_GPS',
  'PORTABLE MEDIA PLAYER': 'PORTABLE_MEDIA_PLAYER',
  'CAR NAVIGATION PORTABLE': 'CAR_NAVIGATION_PORTABLE',
  MEDIATABLETS: 'MEDIATABLETS',
  'ELECTRICAL COOKING POTS': 'ELECTRICAL_COOKING_POTS',
  'CORE WEARABLES': 'CORE_WEARABLES',
  'SMART-MOBPHONES REF': 'SMPPHAB_WITH_REFURB',
  'DESKC.EXCL.MEDIABOX&MEDIASTICK': 'DESKBOUND_COMPUTERS_EXCL_MEDIAGW',
  'DESKTOP COMPUTING': 'DESKBOUND_COMPUTERS_EXCL_MEDIAGW',
  'KEYING DEVICES': 'KEYING_DEV',
  'POINTING DEVICES': 'POINTING_DEV',
  'SOUNDBAR/BASE': 'LOUDSPEAKERS',
  'VISUAL CAMS': 'VISUAL_CAMS',
  'CAIXA AC�STICA': 'LOUDSPEAKERS',
  'V�DEO GAME CONSOLE': 'VIDEO_GAMES_HARDWARE',
  MICROONDAS: 'MICROWAVE_OVENS',
  'M�QUINA DE LAVAR': 'WASHINGMACHINES',
  CAFETEIRA: 'HOT_BEVER_MAKER',
  'BARBEADOR/DEPILADOR': 'MALESHAVERS',
  MONITOR: 'MONITORS',
  HEADSET: 'HEADSETS_TOTAL',
  'MEMORY MODULES': 'MEMORY_MODULES',
  'TUNER/AMPLIFIER/RECEIVER': 'TUNER_AND_AMPLIFIER_AND_RECEIVER',
  'DESK COMPUT.JP': 'DESKBOUND_COMPUTERS_JP',
  MOBILEPHONES: 'MOBILEPHONES',
  'SOUNDBAR/BASE_540': 'SOUNDBAR_BASE',
  'MEDIABOX & MEDIASTICK': 'MEDIABOX_AND_MEDIASTICK',
  'PREPAID CARDS GAMING': 'GAMING_PREPAYCARDS',
  'GAMING EXCL. PREPAID CARDS': 'GAMING_EXCL_PREPAYCARDS',
  'AHS WO. SMART AUDIO': 'AUDIO_HOME_SYS_WITHOUT_SMART_AUDIO',
  'LAUNDRY APPLIANCES BASE': 'LAUNDRY_APPLIANCES_BASE',
  'AR CONDICIONADO': 'AIRCONDITIONING',
  COOKTOP: 'BUILTINHOBS',
  DESKTOP: 'DESKBOUND_COMPUTERS',
  'FOG�O/FORNO': 'COOKING',
  NOTEBOOK: 'MOBILE_COMPUTING',
  'PREPARADORES DE ALIMENTOS': 'FOODPREPARATION',
  'R�DIO PORT�TIL': 'RADIO_DEVICES_(TABLE_TOP)',
  REFRIGERADOR: 'COOLING',
  TABLET: 'MEDIATABLETS',
  TELEVISOR: 'PTV_FLAT',
};

const getItemGroupByProductGroup: (productGroup: string) => string | undefined = productGroup =>
  mapProductGroupNameToItemGroupCode[productGroup];

export default getItemGroupByProductGroup;
